import React from 'react';
import { useTheme } from 'styled-components';

import { PrimaryButton } from '@longline/aqua-ui/controls/PrimaryButton';

interface IPaneCancelButtonProps {
  /** @ignore */
  children?: React.ReactNode;
  onClick: () => void;
}

const PaneCancelButton = (props: IPaneCancelButtonProps) => {
  const theme = useTheme();
  return (
    <PrimaryButton color={theme.colors.neutral[10]} onClick={props.onClick}>{props.children ?? "BACK"}</PrimaryButton>
  )
}

export { PaneCancelButton }
